// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__76g6f","tabUnauthorized":"styles_tabUnauthorized__GqK5x","selectedTabClassName":"styles_selectedTabClassName__pDaqG"};